import React from 'react';
import style from './Navbar.module.scss';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';
import { logout } from '@multiversx/sdk-dapp/utils';
import { ReactComponent as TadaLogo } from 'src/assets/brand/logo.svg';
import { ReactComponent as TadaLogoOnly } from 'src/assets/brand/logo-only.svg';
import { ReactComponent as LogoutIcon } from 'src/assets/icons/logout.svg';
import { ellipsisString } from 'src/helpers/functions';
import { Link, useLocation } from 'react-router-dom';
import { breakpoints, useBreakpoints } from 'src/hooks/useBreakpoints';
import Button from '../Button/Button';

const Navbar = () => {
    const { account } = useGetAccountInfo();
    const isConnected = account && account.address;
    const isMobile = useBreakpoints(breakpoints.xs);
    const location = useLocation();

    const isConnectWalletPage = location.pathname === '/connect-wallet';

    const handleLogout = async () => {
        await logout();
        window.location.href = '/connect-wallet';
    };

    return (
        <nav className={style.navbar}>
            <Link to="/">{isMobile ? <TadaLogoOnly /> : <TadaLogo />}</Link>
            <div>
                {!isMobile && <span className="status">MultiversX</span>}
                {isConnected ? (
                    <>
                        <span className="account">{ellipsisString(account.address, 15)}</span>
                        <button className="logout" onClick={handleLogout}>
                            <LogoutIcon />
                        </button>
                    </>
                ) : (
                    <>
                        {!isConnectWalletPage && (
                            <Button href="/connect-wallet" openInNewTab={false}>
                                Connect
                            </Button>
                        )}
                    </>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
